<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-09 10:59:57
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <!-- <div slot="header">
        <div class="headerCardBox">
          <div style="width:400px">
            类型选择：
            <el-select v-model="value" placeholder="请选择">
              <el-option label="类型1" value="0">类型1</el-option>
              <el-option label="类型2" value="1">类型2</el-option>
            </el-select>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary" @click="TypeChange">查询</el-button>
          <el-button type="primary">重置</el-button>
        </div>
      </div>-->
      <div>
        <div class="adddBtnBox">
          <el-button type="primary" @click="addPopShow=true">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="700" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="areaName" label="区域名"></el-table-column>
          <el-table-column prop="areaCode" label="区域编码"></el-table-column>
          <el-table-column prop="lat" label="经度"></el-table-column>
          <el-table-column prop="lon" label="纬度"></el-table-column>
          <el-table-column prop="stations" label="站点"></el-table-column>

          <el-table-column prop="address" label="操作" width="250">
            <template slot-scope="scope">
              <el-button size="mini" @click="editMsg(scope.row)">修改</el-button>
              <el-popconfirm title="这是一段内容确定删除吗？" @confirm="mydelete(scope.row.id)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1"></el-pagination> -->
    </el-card>
    <el-dialog title="信息新增" :visible.sync="addPopShow" width="30%">
      <el-input placeholder="请输入内容" v-model="addData.areaName">
        <template slot="prepend">区域名</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.areaCode" style="margin-top:10px">
        <template slot="prepend">区域编码</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.lat" style="margin-top:10px">
        <template slot="prepend">经度</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.lon" style="margin-top:10px">
        <template slot="prepend">纬度</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.stations" style="margin-top:10px">
        <template slot="prepend">站点</template>
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="信息修改" :visible.sync="editPopShow" width="30%">
      <el-input placeholder="请输入内容" v-model="editData.areaName">
        <template slot="prepend">区域名</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.areaCode" style="margin-top:10px">
        <template slot="prepend">区域编码</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.lat" style="margin-top:10px">
        <template slot="prepend">经度</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.lon" style="margin-top:10px">
        <template slot="prepend">纬度</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.stations" style="margin-top:10px">
        <template slot="prepend">站点</template>
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      textarea: "",
      input1: "",
      tableData: [],
      value: "0",
      allData: [],
      dialogVisible: false,
      chooseData: {},
      addPopShow: false,
      editPopShow: false,
      addData: {
        areaCode: "",
        areaName: "",
        lat: "",
        lon: "",
        stations: ""
      },
      editData: {}
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    mydelete(data) {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/deleteArea",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          id: data
        }
      }).then(res => {
        // console.log(res.data);
        // this.tableData = res.data;
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.addPopShow = false;
        this.getTableData();
      });
    },
    editMsg(data) {
      console.log(data);
      this.editData = data;
      this.editPopShow = true;
    },
    submitEdit() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/updateArea",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: this.editData
      }).then(res => {
        console.log(res.data);
        this.editPopShow = false;
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.getTableData();
        // this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    },
    submitAdd() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/addArea",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: this.addData
      }).then(res => {
        console.log(res.data);
        this.addPopShow = false;
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.getTableData();
        // this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    },
    sendMsg(data) {
      console.log(data);
      this.chooseData = data;
      this.dialogVisible = true;
    },
    TypeChange() {
      //   this.tableData = this.allData[this.value];
    },
    getTableData() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/getArea",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    }
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
</style>